module.exports = __webpack_public_path__ + "images/scale-a0b74ac8b2cbf7285f8456be68d28992.jpg";